// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpandableQuestionDetails_container__24N59"};